<template>
  <div>
    <modal name="customMessageModal" class="event-modal right-modal custom-modal" :width='"50%"' :height="'auto'"
           :scrollable="true" :pivotX="1.0" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose">
      <div class="modal-box">
        <div :class="{'isLoading': isLoading, 'noDisplay': !isLoading}" class="overlay">
          <div class="spinner-align">
            <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
          </div>
        </div>
        <div class="main-content" v-if="!isLoading">
          <div class="modal-close-img" @click="hideModal()" @mouseover="isHoverClose = true"
             @mouseleave="isHoverClose = false">
          <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
          <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
        </div>
        <div class="modal-title">Client Details</div>
        <button class="configure-scheduler ap-btn secondary" @click="openSchedulerConfig()">
          CONFIGURE SCHEDULER
        </button>
        <div class="modal-header">
          <div class="modal-header-text-edit">
            <textarea v-model="clientName" class="input-client-name" @keyup="bIsSaveClientName = true"></textarea>
            <b-button class="save-client-name-btn" @click="saveClientName({clientId: clientId, clientName: clientName})"
                      v-if="bIsSaveClientName">
              <Icon name="file-save-o"></Icon>
              <span class="dt-group-btn-func-btn-left-text">SAVE</span>
            </b-button>
          </div>
        </div>
        <div class="modal-body main-content">
          <CustomMessageSectionSubmission :content="submissionMessage"
                                          v-on:UPDATE_MESSAGE="callSaveMessage"></CustomMessageSectionSubmission>
          <CustomMessageSectionChangeOrder :content="changeOrderMessage"
                                           v-on:UPDATE_MESSAGE="callSaveMessage"></CustomMessageSectionChangeOrder>
        </div>
        <div class="add-on">
          <div class="title">
            Add-on configuration
          </div>
          <div class="description">
            Toggle availability of add-on services this client can select when requesting a new event.
          </div>
          <div v-for="(item, index) in addOns" :key="index" class="add-on-item">
            <span class="text">{{ item.text }}</span>
            <input v-if="item.key === 'fluShots'" type="checkbox" :id="item.key" v-model="item.value" :disabled="!isAdminUser"
                   @change="checkboxToggle(item.key, item.value)"/>
            <input v-else type="checkbox" :id="item.key" v-model="item.value"
                   @change="checkboxToggle(item.key, item.value)"/><label :for="item.key">Toggle</label>
          </div>
        </div>
        <div class="secondary-am">
          <div class="title">
            Secondary Account Manager
          </div>
          <div class="description">
            Assign a secondary account manager.
          </div>
          <div class="pick custom-multiselect">
            <multiselect v-model="secondaryAMSelected" :options="listSecondaryAM" placeholder="Secondary account manager"
                         label="name" :openDirection="'below'" class="input-second-am" :multiple="true"
                         :close-on-select="true" :hide-selected="true" track-by="id" :allow-empty="true"
                         :show-labels="false" @select="selectSecondaryAM" @remove="removeAM">
              <!-- <template slot="option" scope="props">
                <div class="list-second-am">
                  <span class="item custom__tag" v-html="props.option.name"></span>
                </div>
              </template> -->
            </multiselect>
            </div>
          </div>
          <div class="reseller-status">
            <div class="title">
              Reseller Status
            </div>
            <div class="description">
              Toggle client status as a reseller and assign subclients.
            </div>
            <div class="reseller-toggle">
              <span class="text">Reseller</span>
              <input type="checkbox" id="reseller" :disabled="managedByClientId != null" v-model="resellerToggle"
                    @change="resellerToggleCheck(resellerToggle)"/><label for="reseller">Toggle</label>
            </div>
            <div class="read-only custom-toggle" v-if="resellerToggle">
              <span class="text">Read Only</span>
              <input type="checkbox" id="readOnly" v-model="readOnlyToggle"
                    @change="readOnlyToggleCheck(readOnlyToggle)"/><label for="readOnly">Toggle</label>
            </div>
            <div class="pick custom-multiselect">
              <multiselect v-if="resellerToggle" v-model="subClientSelected" :options="listSubClient"
                          placeholder="Search for client to add" label="clientName" :openDirection="'below'"
                          class="input-second-am" :show-no-results="false" :multiple="true" :close-on-select="true"
                          :hide-selected="true" track-by="clientId" :allow-empty="true" :show-labels="false"
                          @select="selectSubClient" @remove="removeSubClient">
              </multiselect>
            </div>
          </div>
          <div class="secondary-am">
            <div class="title">
              Validators
            </div>
            <div class="description">
              Assign Validators for clients.
            </div>
            <div class="pick last-child-pick custom-multiselect">
              <multiselect v-model="selectedValidators" :options="listValidators"
                          placeholder="Choose or select validators"
                          label="name" :openDirection="'below'" class="input-second-am" :multiple="true"
                          :close-on-select="true" :hide-selected="true" track-by="id" :allow-empty="true"
                          :show-labels="false" @select="addValidators">
                <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span>{{props.option.name}}</span>
                      <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="removeValidators(props.option)" v-if="!readOnlyTaggingValidators(props.option)"></i>
                    </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <ConfigureSchedulerModal/>
    <ModalChangeToggleVaccines
      :onCheckToggleOnOff="processUpdateAddons"
      :addOns="addOns"
      :nameModal="modalVaccineChangeConfirmationName"
      :textQuestion="textTurnOffVaccineConfirmation"
      :listTextDescription="textTurnOffVaccineConfirmationDescription"
    />
  </div>
</template>
<script>
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';
  import Multiselect from 'vue-multiselect';
  import CustomMessageSectionSubmission from './CustomMessageSectionSubmission';
  import CustomMessageSectionChangeOrder from './CustomMessageSectionChangeOrder';

  import {mapGetters, mapActions, mapMutations} from 'vuex';

  import constant from '../../_consts';
  import ConfigureSchedulerModal from './ConfigureSchedulerModal';
  import ModalChangeToggleVaccines from './ModalChangeToggleVaccines';
  export default {
    name: '',
    components: {
      ConfigureSchedulerModal,
      Icon,
      CustomMessageSectionSubmission,
      CustomMessageSectionChangeOrder,
      Multiselect,
      ModalChangeToggleVaccines
    },
    data () {
      return {
        isHoverClose: false,
        isExpanded: false,
        submissionMessage: '',
        changeOrderMessage: '',
        clientName: '',
        bIsSaveClientName: false,
        clientId: '',
        addOns: [
          {
            key: 'venipuncture',
            text: 'Venipuncture',
            value: false
          },
          {
            key: 'cotinine',
            text: 'Cotinine',
            value: false
          },
          {
            key: 'wbaStation',
            text: 'WBA Station',
            value: false
          },
          {
            key: 'fluShots',
            text: 'Vaccines (Flu Shots/Covid-19 Vaccines)',
            value: false
          },
          {
            key: 'paperScheduler',
            text: 'Paper Scheduler',
            value: false
          },
          {
            key: 'smallSiteModel',
            text: 'Micro Site Model',
            value: false
          },
          {
            key: 'smallSiteConcierge',
            text: 'Micro Site Concierge',
            value: false
          },
          {
            key: 'tobaccoSelfAttestation',
            text: 'Tobacco Self Attestation',
            value: false
          },
          {
            key: 'isUseSalesforce',
            text: 'Salesforce Sync (turn off for Shiftboard Sync)',
            value: false
          }
        ],
        listSecondaryAM: [],
        secondaryAMSelected: [],
        listSubClient: [],
        subClientSelected: [],
        resellerToggle: false,
        managedByClientId: null,
        readOnlyToggle: false,
        selectedValidators: [],
        textTurnOffVaccineConfirmation: 'Are you sure you want to change the Vaccine Toggle from "ON" to "OFF"?',
        textTurnOffVaccineConfirmationDescription: ['All scheduled vaccine related events and slots will be cancelled.', 'Members with scheduled vaccine related appointments will receive a cancellation email.'],
        modalVaccineChangeConfirmationName: 'modalVaccineChangeConfirmationName',
        isLoading: false
      }
    },
    methods: {
      openSchedulerConfig () {
        this.$modal.show('configureSchedulerModal', {clientId: this.clientId});
      },
      hideModal () {
        this.$modal.hide('customMessageModal');
      },
      beforeOpen (client) {
        this.isLoading = true;
        this.getClient(client.params).then(response => {
          let result = response.data.data;
          this.clientName = result.clientName || '';
          this.clientId = result.id || '';
          this.submissionMessage = result.submissionMessage || constant.defaultModalMessage.submissionMessage;
          this.changeOrderMessage = result.changeOrderMessage || constant.defaultModalMessage.changeOrderMessage;
          // Binding data for Additional services
          if (result && result.addOns) {
            let arrAddOns = result.addOns.split(',');
            this.addOns.forEach(addOn => { addOn.value = false });
            this.addOns.forEach(element => {
              arrAddOns.forEach(ele => {
                if (ele === element.key) {
                  element.value = true;
                }
              })
            });
          }
          // Binding data for Secondary AM
          let listAM = this.listAM;
          let secondaryAMSelected = [];
          let listSecondaryAM = [];
          if (listAM !== null) {
            listAM.forEach(element => {
              if (element.id !== result.managedBy) {
                element['name'] = element.firstName + ' ' + element.lastName;
                listSecondaryAM.push(element);
              }
            });
          }
          if (result && result.secondaryAMList) {
            result.secondaryAMList.forEach(element => {
              element['name'] = element.firstName + ' ' + element.lastName;
              secondaryAMSelected.push(element);
            });
          }
          this.secondaryAMSelected = secondaryAMSelected;
          this.listSecondaryAM = listSecondaryAM;
          // Binding data for Reseller
          let listSubClient = [];
          let subClientSelected = [];
          this.resellerToggle = (result && result.isResellerCheck);
          if (result && result.unAssignedClients) {
            result.unAssignedClients.forEach(element => {
              listSubClient.push(element);
            });
          }
          if (result && result.subClients) {
            result.subClients.forEach(element => {
              listSubClient.push(element);
              subClientSelected.push(element);
            });
          }
          this.listSubClient = listSubClient;
          this.subClientSelected = subClientSelected;
          this.managedByClientId = result.managedByClientId || null;
          this.readOnlyToggle = (result && result.readOnly);
          this.getAllValidators();
          this.getValidatorsByClientId(result.id).then((response) => {
            this.selectedValidators = response.validators;
          });
        }).finally(() => {
          this.isLoading = false;
        });
      },
      beforeClose () {
        // this.secondaryAMSelected = [];
        // this.subClientSelected = [];
        // this.listSecondaryAM = [];
        // this.listSubClient = [];
        // this.resellerToggle = false;
        this.getClients();
      },
      callSaveMessage (updateObj) {
        this.updateMessage({
          type: updateObj.type,
          content: updateObj.content,
          clientId: this.clientId
        }).then(() => {
          this.getClients();
        });
      },
      checkboxToggle (key, value) {
        let obj = {
          clientId: this.clientId,
          key: key,
          isAdd: value
        };
        if (key === 'fluShots' && !value) {
          this.$modal.show(this.modalVaccineChangeConfirmationName, obj);
          return;
        }
        this.processUpdateAddons(obj);
      },
      selectSecondaryAM (selectedOption) {
        let obj = {
          clientId: this.clientId,
          user: selectedOption,
          isAdd: true
        };
        this.updateSecondaryAM(obj);
      },
      removeAM (removedOption) {
        let obj = {
          clientId: this.clientId,
          user: removedOption,
          isAdd: false
        };
        this.updateSecondaryAM(obj);
      },
      addValidators (value) {
        let obj = {
          clientId: this.clientId,
          validatorId: value.id,
          isAdd: true
        };
        this.updateValidatorsToClient(obj).then((response) => {
          this.selectedValidators = response.validators;
        });
      },
      removeValidators (value) {
        let obj = {
          clientId: this.clientId,
          validatorId: value.id,
          isAdd: false
        };
        this.updateValidatorsToClient(obj).then((response) => {
          this.selectedValidators = response.validators;
        });
      },
      resellerToggleCheck (value) {
        let obj = {
          clientManager: this.clientId,
          isReseller: value
        };
        this.updateSubClient(obj);
      },
      selectSubClient (selectedOption) {
        let obj = {
          clientManager: this.clientId,
          subClient: selectedOption.clientId
        };
        this.updateSubClient(obj).then(() => {
        });
      },
      removeSubClient (removedOption) {
        let obj = {
          clientManager: this.clientId,
          subClient: removedOption.clientId
        };
        this.updateSubClient(obj).then(() => {
        });
      },
      readOnlyToggleCheck (value) {
        let obj = {
          id: this.clientId,
          readOnly: value
        };
        this.updateReadOnly(obj);
      },
      readOnlyTaggingValidators (item) {
        return ['firstName', 'lastName', 'employeeId', 'cardCode', 'email'].includes(item.frontEndField);
      },
      processUpdateAddons (obj) {
        this.updateAddOn(obj).then((rs) => {
          if (rs.message) {
            const currentAddOn = this.addOns.find(addOn => addOn.key === obj.key);
            currentAddOn.value = !obj.isAdd;
          } else {
            this.$modal.hide(this.modalVaccineChangeConfirmationName);
          }
        });
      },
      ...mapActions({
        updateMessage: 'ACTION_UPDATE_MESSAGE',
        updateAddOn: 'UPDATE_ADD_ON',
        getClients: 'ACTION_GET_CLIENTS',
        updateSecondaryAM: 'ACTION_UPDATE_SECONDARY_AM',
        updateSubClient: 'ACTION_UPDATE_SUB_CLIENT',
        updateReadOnly: 'ACTION_UPDATE_READ_ONLY',
        saveClientName: 'ACTION_SAVE_CLIENT_NAME',
        updateValidatorsToClient: 'ACTION_UPDATE_VALIDATORS_TO_CLIENT',
        getAllValidators: 'ACTION_GET_ALL_VALIDATORS',
        getValidatorsByClientId: 'ACTION_GET_VALIDATORS_BY_CLIENT_ID',
        getClient: 'ACTION_GET_CLIENT'
      }),
      ...mapMutations({
        setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {
      isAdminUser () {
        return this.getUserRole === constant.USER_ROLE.admin;
      },
      getUserRole () {
        return localStorage.getItem(constant.LOCAL_STORE.role);
      },
      ...mapGetters({
        getCustomMessage: 'GETTERS_GET_EVENT_HISTORY',
        listAM: 'GETTERS_GET_LIST_AM',
        listValidators: 'GETTER_GET_VALIDATOR_LIST'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// CustomMessageModal.vue?4d363db6